
/**
 * Random variables used in the app
 */
export const KALP_ROUTE_PATH = 'kalp'
export const START_ROUTE_PATH = 'start'
export const LOGIN_ROUTE_PATH = 'login'
export const RESULT_ROUTE_PATH = 'result'

export type THelpSection = 'pers-data' | 'income-cost' | 'new-home' | 'loan'